import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from 'constants/common';
import { AppointmentService } from 'services/appointments';
import { PatientService } from 'services/patients';
import { useUserStore } from 'stores/user';
import { separateAppointmentsByDate } from 'utils/appointments';
import { type NextSession } from './types';

export const useFetchNextSessions = (): UseQueryResult<NextSession[]> => {
  const psychologistId = useUserStore(state => state.user?.id) ?? '';
  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_PSYCHOLOGIST_NEXT_SESSIONS, psychologistId],
    queryFn: async () => {
      const { data: appointments } =
        await AppointmentService.getPsychologistNextSessions(psychologistId);
      const appointmentsWithCenter = await Promise.all(
        appointments.map(async appointment => ({
          ...appointment,
          center: (await AppointmentService.getCenterDetails(appointment.backofficeCenterId)).data,
          patient: (await PatientService.getPatient(appointment.patientId)).data,
        }))
      );
      return separateAppointmentsByDate(appointmentsWithCenter).future as NextSession[];
    },
    enabled: !!psychologistId,
  });
};
